"use client";

import { useContext } from "react";

import { ConsentContext } from "@/core/consent/react/ConsentContext";

export function useConsent() {
  return useContext(ConsentContext);
}
